module.exports = __webpack_public_path__ + "img/about2.f4f265c4.png";